import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { proxiedUrlFor } from "./media-url-utils";

const createLoader = () => {
  const loader = new GLTFLoader();
  const dracoLoader = new DRACOLoader();
  dracoLoader.setDecoderPath(proxiedUrlFor("https://www.gstatic.com/draco/versioned/decoders/1.5.7/"));
  loader.setDRACOLoader(dracoLoader);
  loader.setCrossOrigin("anonymous");
  return { loader, dracoLoader };
};

const getGeometrySize = geometry => {
  if (!geometry) {
    return 0;
  }

  let size = 0;

  if (geometry.index?.array) {
    size += geometry.index.array.byteLength;
  }

  if (geometry.attributes) {
    Object.values(geometry.attributes).forEach(attribute => {
      if (!attribute?.array) {
        return;
      }
      size += attribute.array.byteLength;
    });
  }

  return size;
};

const getTriangles = geometry => {
  if (!geometry) {
    return 0;
  }

  if (geometry.index) {
    return geometry.index.count / 3;
  }

  if (geometry.attributes?.position) {
    return geometry.attributes.position.count / 3;
  }

  return 0;
};

export const loadModelInfo = async url => {
  if (!url) {
    throw new Error("Model URL is required.");
  }

  const { loader, dracoLoader } = createLoader();

  try {
    const gltf = await loader.loadAsync(proxiedUrlFor(url));
    let triangles = 0;
    let totalSize = 0;

    gltf.scene.traverse(object3D => {
      if (!object3D.isMesh || !object3D.geometry) {
        return;
      }
      triangles += getTriangles(object3D.geometry);
      totalSize += getGeometrySize(object3D.geometry);
    });

    dracoLoader?.dispose?.();
    gltf.parser?.dispose?.();

    return {
      triangles,
      totalSize
    };
  } catch (error) {
    dracoLoader?.dispose?.();
    throw error;
  }
};
